<template>
  <div>
    <div class="row" v-if="car.imei">
      <div class="col-sm">imei: {{ car.imei }}</div>
    </div>
    <div class="row" v-if="car.lastState && car.lastState.ignition">
      <div class="col-sm">
        Зажиганее: {{ car.lastState.ignition.value == 1 ? "есть" : "нет" }}
      </div>
    </div>
    <div class="row" v-if="car.lastState && car.lastState.lat">
      <div class="col-sm">Скорость: {{ Math.round(car.lastState.speed.value) }} км/ч</div>
    </div>
    <div class="row" v-if="car.lastState && car.lastState.lat && car.lastState.lng">
      <div class="col-sm">
        Координаты: {{ car.lastState.lat.value }}, {{ car.lastState.lng.value }}
      </div>
    </div>
    <div class="row" v-if="car.lastState && car.lastState.lat">
      <div class="col-sm">
        Дата последней отправки данных:
        {{ toLocalTime(car.lastState.lat.timestamp) }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm" v-if="car">
        Пробег:
        {{
          actualOdometer + " км "
        }}
        <span v-if="car.lastState && car.lastState.totalOdometer">(по датчику
        {{
          ' ' +car.lastState
            ? Math.round(car.lastState.totalOdometer.value / 1000) + " км)"
            : "-"
        }}</span>
      </div>
    </div>
    <hr>
    <h5 class="text-center">Маршрут</h5>
    <div class="my-2">Начало</div>
    <div class="row">
      <div class="col">
        <input
          class="w-100 form-control"
          type="datetime-local"
          placeholder="Начало маршрута"
          v-model="timeStartRoute"
        />
      </div>
    </div>
    <div class="my-2">Окончание</div>
    <div class="row">
      <div class="col">
        <input
          class="w-100 form-control"
          type="datetime-local"
          placeholder="Начало маршрута"
          v-model="timeEndRoute"
        />
      </div>
    </div>
    <button class="input-group-btn btn btn-primary my-4 align-content-center w-100" @click="getTrack()">Показать</button>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import odometerCorrectionApi from '@/api/odometercorrection'

export default {
  name: 'MapCardInfo',
  data () {
    return {
      actualOdometer: 0,
      timeStartRoute: null,
      timeEndRoute: null
    }
  },
  computed: {
    ...mapState('taxi/mapcars', {
      car: state => state.items.find(car => car.id === state.selectedCar.id)
    })
  },
  mounted () {
    this.timeStartRoute = new Date()
    this.timeEndRoute = new Date()
  },
  watch: {
    car: {
      handler (car, carOld) {
        if (car?.id !== carOld?.id) {
          odometerCorrectionApi.getActualOdometer({ id: this.car.id })
            .then(odometer => {
              this.actualOdometer = odometer
            })
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'getStartTrack'
    ]),
    toLocalTime (date) {
      date = new Date(date + 'Z')
      return date.toLocaleString()
    },
    getTrack () {
      this.getStartTrack({
        id: this.car.id,
        startTimeOfTrack: dayjs(new Date(this.timeStartRoute) - (60 * 60 * 1000) * 5).format('YYYY-MM-DDTHH:mm:ss'),
        endTimeOfTrack: dayjs(new Date(this.timeEndRoute) - (60 * 60 * 1000) * 5).format('YYYY-MM-DDTHH:mm:ss')
      })
    }
  }
}
</script>
